// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"checkboxCell_checkboxWrapper__1XH7k"};